import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../services/ReactQuery/reactQueryService";
import { PartnerCategory, PartnerReference, RuntimePartnerReference } from "../types/PartnerReference";
import { buildPartnerRegistry, getPartnerRegistry, PartnerRegistry, setPartnerRegistry } from "../services/partnerReferenceService";

type UsePartnerRegistryResult = {
  partners: RuntimePartnerReference[];
  activePartners: RuntimePartnerReference[];
  partnersBySlug: Record<string, RuntimePartnerReference>;
  partnersByIri: Record<string, RuntimePartnerReference>;
  partnerRegistry: PartnerRegistry;
  isLoading: boolean;
};

const getMembers = (response: any): PartnerReference[] => response?.["hydra:member"] ?? [];
const withPartnerCategory = (partners: PartnerReference[], partnerCategory: PartnerCategory): RuntimePartnerReference[] =>
  partners.map((partner) => ({ ...partner, partnerCategory }));

export default function usePartnerRegistry(): UsePartnerRegistryResult {
  const insurerPartnerQuery = useQuery({
    queryKey: queryKeys.collection("insurer_partners", { pagination: false }),

    queryFn: () =>
      fetchCollection("insurer_partners", { pagination: false })
  });
  const affiliatePartnerQuery = useQuery({
    queryKey: queryKeys.collection("affiliate_partners", { pagination: false }),

    queryFn: () =>
      fetchCollection("affiliate_partners", { pagination: false })
  });

  const isLoading = insurerPartnerQuery.isLoading || affiliatePartnerQuery.isLoading;

  if (isLoading) {
    const partnerRegistry = getPartnerRegistry();

    return {
      partners: partnerRegistry.partners,
      activePartners: partnerRegistry.activePartners,
      partnersBySlug: partnerRegistry.partnersBySlug,
      partnersByIri: partnerRegistry.partnersByIri,
      partnerRegistry,
      isLoading: true,
    };
  }

  const partnerRegistry = buildPartnerRegistry({
    insurerPartners: withPartnerCategory(getMembers(insurerPartnerQuery.data), "insurer"),
    affiliatePartners: withPartnerCategory(getMembers(affiliatePartnerQuery.data), "affiliate"),
  });

  setPartnerRegistry(partnerRegistry);

  return {
    partners: partnerRegistry.partners,
    activePartners: partnerRegistry.activePartners,
    partnersBySlug: partnerRegistry.partnersBySlug,
    partnersByIri: partnerRegistry.partnersByIri,
    partnerRegistry,
    isLoading: false,
  };
}
